module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-button-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "pure-button radio radio-left",
    class: {
      active: _vm.value
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateValue(true)
      }
    }
  }, [_vm._v("Yes\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "pure-button radio radio-right",
    class: {
      active: !_vm.value
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateValue(false)
      }
    }
  }, [_vm._v("No\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ecb9b00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/start/YesNo.vue
// module id = 368
// module chunks = 1